import { v4 as uuidv4 } from 'uuid';
import { View, Level } from '../../core/types';
import { BaseTool } from '../BaseTool';

export class FloorPlanTool extends BaseTool {
    id = 'VIEW_PLAN';
    name = 'Floor Plan';
    cursor = 'default';

    onActivate(): void {
        const selection = this.context?.appStore.selectedIds || [];
        if (!this.context) return;

        // Resolve selected ids against both datum maps (project.levels is the
        // canonical datum registry the LevelRenderer draws from) and the
        // elements map (Levels elements mirror datums for properties).
        const levels = selection
            .map(id =>
                this.context!.bimStore.project.levels.get(id) ??
                this.context!.bimStore.project.elements.get(id)
            )
            .filter(el => !!el && ('isStory' in el || (el as any).category === 'Levels'))
            .map(el => el as Level);

        if (levels.length > 0) {
            levels.forEach(level => this.createPlanForLevel(level));
            this.deactivate();
            this.context?.appStore.setActiveTool('select');
        } else {
            console.warn('Select one or more Levels to create Floor Plans.');
            // Ideally prompt UI to select level
            this.deactivate();
            this.context?.appStore.setActiveTool('select');
        }
    }

    private createPlanForLevel(level: Level) {
        if (!this.context) return;

        const viewId = uuidv4();
        const levelName = level.name || 'Level';

        const newView: View = {
            id: viewId,
            name: `Floor Plan - ${levelName}`,
            type: 'FloorPlan',
            discipline: 'Architectural',
            scale: 100,
            detailLevel: 'Medium',
            visibility: {},
            filters: [],
            associatedLevelId: level.id,
            viewRange: {
                top: 2.3, // meters above level
                cutPlane: 1.2,
                bottom: 0,
                depth: 0
            },
            camera: {
                position: [0, 0, 100], // Placeholder, will be set by viewport
                target: [0, 0, 0],
                projection: 'Orthographic'
            }
        };

        this.context.bimStore.addView(newView);
        console.log(`Created Floor Plan: ${newView.name}`);

        // Switch to new view?
        this.context.bimStore.setActiveView(viewId);
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
